import React from 'react'
import {Button, Label} from 'reactstrap'
import {AvFeedback, AvForm, AvGroup, AvInput} from 'availity-reactstrap-validation'
import Loader from 'react-loader-spinner'
import AccountIcon from 'react-icons/lib/fa/user'
import '../../stylesheets/Users.css'

const modelFromUser = (user) => {
    return {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email
    }
}

class AccountSettingsForm extends React.Component {
    constructor(props) {
        super(props)

        let {onValidSubmit, onInvalidSubmit, managingOtherUser, loading, user} = props
        this.onValidSubmit = onValidSubmit
        this.onInvalidSubmit = onInvalidSubmit
        this.state = {
            model: modelFromUser(user),
            managingOtherUser,
            loading,
        }
    }

    componentWillReceiveProps(nextProps) {
        let {onValidSubmit, onInvalidSubmit, managingOtherUser, loading, user} = nextProps
        this.onValidSubmit = onValidSubmit
        this.onInvalidSubmit = onInvalidSubmit
        this.setState({
            model: modelFromUser(user),
            managingOtherUser,
            loading,
        })
    }

    render() {
        let {model, managingOtherUser, loading} = this.state
        return <div className="m-0 p-0">
            <h1 className="text-center mb-4 form-head"><AccountIcon
                className="light-sf-blue"/> Manage {managingOtherUser ? "" : "Your "}Account</h1>
            {loading ? <div className="w-100 h-100 text-center">
                    <Loader type="TailSpin" color="orange" width={60} height={60}/>
                </div> :
                <AvForm onValidSubmit={this.onValidSubmit}
                        onInvalidSubmit={this.onInvalidSubmit}
                        model={model}
                        className="align-content-center">
                    <AvGroup
                        className="col-12 offset-0 col-sm-10 offset-sm-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
                        <Label for="firstName">First Name</Label>
                        <AvInput name="firstName"
                                 placeholder="First Name"
                                 type="text"
                                 autoComplete="given-name"
                                 required/>
                        <AvFeedback>Please enter your first name.</AvFeedback>
                    </AvGroup>
                    <AvGroup
                        className="col-12 offset-0 col-sm-10 offset-sm-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
                        <Label for="lastName">Last Name</Label>
                        <AvInput name="lastName"
                                 placeholder="Last Name"
                                 type="text"
                                 autoComplete="family-name"
                                 required/>
                        <AvFeedback>Please enter your last name.</AvFeedback>
                    </AvGroup>
                    <AvGroup
                        className="col-12 offset-0 col-sm-10 offset-sm-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
                        <Label for="email">Email Address</Label>
                        <AvInput name="email"
                                 placeholder="you@email.com"
                                 type="email"
                                 autoComplete="email"
                                 required/>
                        <AvFeedback>Please enter a valid email address.</AvFeedback>
                    </AvGroup>
                    <AvGroup
                        className="col-12 offset-0 col-sm-10 offset-sm-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
                        <Label for="password">Password</Label>
                        <AvInput name="password"
                                 placeholder="********"
                                 type="password"
                                 validate={{minLength: {value: 8}}}
                                 onChange={e => this.setState({passwordInputValue: e.target.value})}
                                 autoComplete="new-password"/>
                        <AvFeedback>Please enter a password (at least 8 characters long.)</AvFeedback>
                    </AvGroup>
                    <AvGroup
                        className="mb-5 col-12 offset-0 col-sm-10 offset-sm-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
                        <Label for="confirmPassword">Confirm Password</Label>
                        <AvInput name="confirmPassword"
                                 placeholder="********"
                                 type="password"
                                 validate={{match: {value: 'password'}}}
                                 required={this.state.passwordInputValue}
                                 autoComplete="new-password"/>
                        <AvFeedback>Passwords do not match</AvFeedback>
                    </AvGroup>
                    <AvGroup className="justify-content-center text-center">
                        <Button className="col-10 col-sm-7 col-lg-3">Save Account Settings</Button>
                    </AvGroup>
                </AvForm>}
        </div>
    }
}

export default AccountSettingsForm



// WEBPACK FOOTER //
// ./src/components/ui/AccountSettingsForm.js